import { Link } from "react-router-dom";
import { Truck, Clock, RotateCcw, Lock } from "lucide-react";

/**
 * Trust-panel som vises under kjøpsknappen på produktsiden.
 * Samler frakt, leveringstid, angrerett og sikkerhetssignaler i én
 * kompakt boks slik at kunden ikke trenger å gå til kjøpsvilkår først.
 */
export function ProductTrustPanel() {
  const items: Array<{
    icon: typeof Truck;
    title: string;
    body: React.ReactNode;
  }> = [
    {
      icon: Truck,
      title: "Frakt",
      body: (
        <>
          <strong>99 kr</strong> med Posten, eller <strong>gratis henting</strong>{" "}
          i Drammen.
        </>
      ),
    },
    {
      icon: Clock,
      title: "Leveringstid",
      body: (
        <>
          Sendes innen <strong>1-2 virkedager</strong>, fremme på{" "}
          <strong>2-5 virkedager</strong>.
        </>
      ),
    },
    {
      icon: RotateCcw,
      title: "Angrerett",
      body: (
        <>
          <strong>14 dagers</strong> angrerett — angreskjema følger med
          bekreftelsen.{" "}
          <Link
            to="/kjopsvilkar"
            className="text-primary underline-offset-2 hover:underline"
          >
            Les vilkårene
          </Link>
          .
        </>
      ),
    },
    {
      icon: Lock,
      title: "Sikker betaling",
      body: <>Kort, Klarna og Vipps via Kustom Checkout.</>,
    },
  ];

  return (
    <div className="mt-6 rounded-2xl border border-border bg-card p-5">
      <ul className="space-y-4">
        {items.map(({ icon: Icon, title, body }) => (
          <li key={title} className="flex items-start gap-3">
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <Icon size={16} aria-hidden="true" />
            </span>
            <div className="text-sm font-body leading-relaxed">
              <p className="font-semibold text-foreground">{title}</p>
              <p className="text-muted-foreground">{body}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

/**
 * Kompakte betalings-badges under kjøpsknappen — viser hvilke metoder
 * kunden kan bruke uten at vi trenger tunge logo-bilder.
 */
export function PaymentBadges() {
  const methods = ["Klarna", "Vipps", "Visa", "Mastercard"];
  return (
    <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
      <span className="text-xs uppercase tracking-[0.15em] text-muted-foreground font-body">
        Vi støtter
      </span>
      {methods.map((m) => (
        <span
          key={m}
          className="rounded-md border border-border bg-card px-2 py-0.5 text-xs font-semibold font-body text-foreground/80"
        >
          {m}
        </span>
      ))}
    </div>
  );
}
